var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white rounded p-16 shadow"},[_c('p',{staticClass:"mb-4"},[_vm._v("建物コードを入力してください")]),_c('search-form',{attrs:{"placeholder":"建物コードを入力してください (一部でも可)"},on:{"search":_vm.search}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }